module.exports = __webpack_public_path__ + "img/500.1d964cd1.svg";